import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Starter',
  price: '€29',
  description: 'Perfect for casual gamers starting their journey.',
  features: ['Basic Avatar Design', '1 Revision Round', '1 Art Style', 'High-Res PNG/JPG', 'Personal Use License'],
  cta: 'Start Basic',
  variant: 'outline' as const
}, {
  name: 'Pro',
  price: '€79',
  description: 'The most popular choice for streamers and content creators.',
  features: ['Detailed Avatar Design', '3 Revision Rounds', '2 Art Styles', 'Expressions Pack (3)', 'Commercial Use License', 'Social Media Kit'],
  cta: 'Go Pro',
  popular: true,
  variant: 'primary' as const
}, {
  name: 'Ultimate',
  price: '€149',
  description: 'For those who want the absolute best digital identity.',
  features: ['Premium Avatar Design', 'Unlimited Revisions', 'All Art Styles', 'Full Animation Pack', 'Source Files (PSD/AI)', 'Priority Support'],
  cta: 'Get Ultimate',
  variant: 'outline' as const
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-[#0B0B15] relative" data-id="element-156">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-fuchsia-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-157" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-5xl font-bold font-display mb-4" data-id="element-160">
            Invest in Your <span className="text-fuchsia-500" data-id="element-161">Identity</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-162">
            Transparent pricing. No hidden fees. Own your look forever.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-start" data-id="element-163">
          {plans.map((plan, index) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative rounded-3xl p-8 border ${plan.popular ? 'bg-[#1A1A2E] border-fuchsia-500 shadow-2xl shadow-fuchsia-900/20 scale-105 z-10' : 'bg-white/5 border-white/10 hover:border-white/20'} transition-all duration-300`} data-id="element-164">
              {plan.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-fuchsia-600 to-purple-600 text-white text-sm font-bold px-4 py-1 rounded-full shadow-lg" data-id="element-165">
                  MOST POPULAR
                </div>}

              <h3 className="text-xl font-bold text-white mb-2 font-display" data-id="element-166">
                {plan.name}
              </h3>
              <div className="flex items-baseline gap-1 mb-4" data-id="element-167">
                <span className="text-4xl font-bold text-white" data-id="element-168">
                  {plan.price}
                </span>
                <span className="text-gray-400" data-id="element-169">/one-time</span>
              </div>
              <p className="text-gray-400 text-sm mb-8 h-10" data-id="element-170">
                {plan.description}
              </p>

              <Button variant={plan.variant} className="w-full mb-8" data-id="element-171">
                {plan.cta}
              </Button>

              <ul className="space-y-4" data-id="element-172">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-173">
                    <Check className={`w-5 h-5 shrink-0 ${plan.popular ? 'text-fuchsia-500' : 'text-gray-500'}`} data-id="element-174" />
                    {feature}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}